export default "<kt-splash-screen *ngIf=\"loader\"></kt-splash-screen>\r\n<router-outlet></router-outlet>\r\n"